var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-list"},[_c('tabs',{attrs:{"items":_vm.tabs,"active-tab":_vm.$route.fullPath},on:{"click":_vm.activateTab}}),_c('el-card',{staticClass:"contains-table",attrs:{"shadow":"always"}},[_c('router-view',{staticClass:"account-form"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }